<template>
  <v-card class="mx-auto">
    <v-card-title>Pertinent Past Medical History</v-card-title>
    <v-card-text>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-textarea
          v-model="formData.past_medical.past_medical"
          outlined
          name="input-7-4"
          label="Past medical history"
          required
          :rules="[v => !!v || 'Past Medical History is required']"
        ></v-textarea>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        :disabled="currentTab === 0"
        @click="backTab"
        color="info"
        class="mr-4">
        BACK
      </v-btn>
      <v-btn
        :disabled="!formData.past_medical.past_medical"
        @click="validate"
        color="success"
        class="mr-4">
        NEXT
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
    export default {
        props: {
            currentTab: Number,
            formData: {
                required: true,
                type: Object
            }
        },

        data() {
            return {
                modal: false,
                valid: false,
            }
        },

        methods: {
            validate() {
                if (this.$refs.form.validate()) {
                    this.snackbar = true;
                    this.$bus.emit('nextTab', this.currentTab + 1);
                }
            },
            reset() {
                this.$refs.form.reset()
            },
            backTab() {
                this.$bus.emit('nextTab', this.currentTab - 1);
            }
        },
    }
</script>

<style scoped>

</style>
